import {
  ISurveyBlockModel,
  IMultimediaBlockModel,
  IEvaluationBlockModel,
  IScormBlockModel,
  IMeetingBlockModel,
  ISessionBlockEditModel,
} from 'models/block.model'
import { IRichTextBlockModel } from 'models/blockRichText.model'
import api from '../..'

export const editSurveyBlockDetails = (
  surveysBlockId: number,
  data: ISurveyBlockModel
) => {
  return api.patch(`administration/block_surveys/${surveysBlockId}`, data)
}
export const editRichTextBlock = (
  richTextBlockId: number,
  data: IRichTextBlockModel
) => {
  return api.patch(`administration/block_rich_texts/${richTextBlockId}`, data)
}
export const editTaskBlock = (
  taskBlockId: number,
  data: IRichTextBlockModel
) => {
  return api.patch(`administration/block_tasks/${taskBlockId}`, data)
}
export const editMultimediaBlock = (
  multimediaBlockId: number,
  data: IMultimediaBlockModel
) => {
  return api.patch(
    `administration/block_multimedias/${multimediaBlockId}`,
    data
  )
}
export const editScormBlock = (
  ScormBlockId: number,
  data: IScormBlockModel
) => {
  return api.patch(`administration/block_scorm/${ScormBlockId}`, data)
}
export const editMeetingBlock = (id: number, data: IMeetingBlockModel) => {
  return api.patch(`administration/block_meeting/${id}`, data)
}
export const editSessionBlock = (id: number, data: ISessionBlockEditModel) => {
  return api.patch(`administration/block_session/${id}`, data)
}
export const editEvaluationBlock = (
  evaluationBlockId: number,
  data: IEvaluationBlockModel
) => {
  return api.patch(
    `/administration/block_evaluations/${evaluationBlockId}`,
    data
  )
}

export const editBlocksOrder = (lessonId: number, blocks: number[]) => {
  return api.post(`/administration/lessons/${lessonId}/block_instances/order`, {
    ids: blocks,
  })
}
